import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { PrivaLocalizationModule } from '@priva/localization';

import { AppWizardComponent } from 'app/features/setup-wizard/components';
import { AppWelcomeWizardStepComponent } from 'app/features/setup-wizard/pages/steps/app-welcome-wizard-step/app-welcome-wizard-step.component';
import { EnterSecurityPinWizardStepComponent } from 'app/features/setup-wizard/pages/steps/enter-security-pin-wizard-step/enter-security-pin-wizard-step.component';
import { LoadMasterDataWizardStepComponent } from 'app/features/setup-wizard/pages/steps/load-master-data-wizard-step/load-master-data-wizard-step.component';
import { SiteConnectWizardStepComponent } from 'app/features/setup-wizard/pages/steps/site-connect-wizard-step/site-connect-wizard-step.component';

@Component({
    selector: 'app-app-setup-wizard',
    templateUrl: './app-setup-wizard.component.html',
    imports: [
        PrivaLocalizationModule,
        AppWelcomeWizardStepComponent,
        AppWelcomeWizardStepComponent,
        AppWizardComponent,
        EnterSecurityPinWizardStepComponent,
        LoadMasterDataWizardStepComponent,
        SiteConnectWizardStepComponent,
        EnterSecurityPinWizardStepComponent,
    ],
})
export class AppSetupWizardComponent {
    appName = 'Priva Performance Activity';
    constructor(private router: Router) {}

    onSetupWizardCompleted(): void {
        this.navigateToMainScreen();
    }

    private navigateToMainScreen(): void {
        this.router.navigateByUrl('/').then();
    }
}
